import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
            <div className="md:col-span-1">
              <span className="text-xl font-heading font-bold text-white mb-4 block">51吃瓜app</span>
              <p className="text-sm text-background-400 leading-relaxed max-w-xs">
                {footerData.description}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
              <div className="flex flex-col gap-2.5">
                {footerData.links.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500">优质合作伙伴持续接入中，敬请期待</p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-800/50">
            <p className="text-xs text-background-500 text-center">
              &copy; {new Date().getFullYear()} 51吃瓜app —— 每日大赛在线观看，畅享视频吃瓜体验
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}